import { useCallback } from 'react';
import { useMsal, useAccount } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

const useAuth = () => {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || null);

  const login = useCallback(async () => {
    try {
      await instance.loginPopup(loginRequest);
    } catch (err) {
      console.error('Login error:', err);
    }
  }, [instance]);

  const logout = useCallback(() => {
    instance.logoutPopup({ mainWindowRedirectUri: '/' });
  }, [instance]);

  const getToken = useCallback(async () => {
    if (!account) return null;
    try {
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account,
      });
      return response.accessToken;
    } catch (err) {
      // If silent fails, try popup
      try {
        const response = await instance.acquireTokenPopup(loginRequest);
        return response.accessToken;
      } catch (popupErr) {
        console.error('Token error:', popupErr);
        return null;
      }
    }
  }, [instance, account]);

  return {
    user: account
      ? {
          name: account.name,
          email: account.username,
          id: account.localAccountId,
        }
      : null,
    isAuthenticated: !!account,
    login,
    logout,
    getToken,
  };
};

export default useAuth;
